<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Mensagem' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div class="top">

    <ion-grid>
      <ion-row class="header-details">
        <ion-col size="auto">
          <ion-avatar>
            <img [src]="mensagem.pessoaFoto | image:' '" class="avatar-image" />
          </ion-avatar>
        </ion-col>

        <ion-col class="aling-item">
          <ion-label>
            <h2 class="bold-2">{{mensagem.titulo | translate}}</h2>
            <p>{{ mensagem.created_at | dateFormat: "ddmmyyyy" }} {{ mensagem.created_at | dateFormat: 'hora' }}</p>
          </ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card-content>
      <p [innerHTML]="mensagem.conteudo | safeHtml: 'html'"></p>
    </ion-card-content>

    <ion-grid *ngIf="mensagem.links && mensagem.links.length" class="links">
      <ion-row class="header-details">
        <ion-col size="auto">
          <ion-label>
            <h2 class="bold-2 title">{{'Links' | translate}}</h2>
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row 
        *ngFor="let link of mensagem.links" (click)="openLink(link)"
      >
        <ion-col size="10">
          <ion-label>
            <p class="bold-2 nome">{{link.nome}}</p>
          </ion-label>
        </ion-col>

        <ion-col size="auto">
          <ion-label>
            <i class="fa-regular fa-arrow-up-right-from-square icon-list"></i>
          </ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>